import neverLandUtils from "../../utils/NeverLandUtils";
import React from "react";
import {RiCircleFill, RiShapesFill, RiThumbDownFill, RiThumbUpFill} from "react-icons/ri";

const GameStrongPoint = ({teamData, team}) => {


  return (
      <div className="mt-3 flex flex-col">
        {/* <-- 팀 이름 --> */}
        <span
            className={neverLandUtils.classNames(team === "home" ? "bg-red-600" : "bg-blue-600", "text-xl px-5 py-0.5 rounded-full inline-block text-white mb-2")}>
          {teamData?.NAME}
        </span>

        {/* <-- 강점 --> */}
        <div className="flex flex-col mb-3 ring-4 ring-emerald-200 m-1 rounded-lg shadow-lg py-1">
          <div
              className="flex flex-row items-center mb-1 text-emerald-600">
            <RiThumbUpFill className="h-5 w-auto px-2"/>
            <p className="text-lg">강점</p>
          </div>

          <div className="flex flex-col divide-y divide-emerald-200">
            {teamData?.STRONG && teamData.STRONG.length > 0 && !(teamData.STRONG.length === 1 && teamData.STRONG[0].txt === "-" && teamData.STRONG[0].stat === "-") ? (
                teamData.STRONG.map((data, index) => (
                    <div key={index} className="flex flex-row justify-between w-full items-center py-0.5 text-sm p-1">
                      <p className="w-3/4 pl-1 whitespace-nowrap overflow-hidden text-ellipsis truncate">{data.txt}</p>
                      <p
                          className={neverLandUtils.classNames(
                              data.stat === "강함" ? "bg-sky-200 text-black" : "bg-sky-700 text-white",
                              "w-16 bg-amber-200 rounded-full px-1 text-center"
                          )}
                      >
                        {data.stat}
                      </p>
                    </div>
                ))
            ) : (
                <p className="pl-2 text-gray-400">데이터가 없습니다.</p>
            )}
          </div>
        </div>

        {/* <-- 약점 --> */}
        <div className="flex flex-col mb-3 ring-4 ring-rose-200 m-1 rounded-lg shadow-lg py-1">
          <div className="flex flex-row items-center mb-1 text-rose-600">
            <RiThumbDownFill className="h-5 w-auto px-2"/>
            <p className="text-lg">약점</p>
          </div>

          <div className="flex flex-col divide-y divide-rose-200">
            {teamData?.WEAKNESS && teamData.WEAKNESS.length > 0 && !(teamData.WEAKNESS.length === 1 && teamData.WEAKNESS[0].txt === "-" && teamData.WEAKNESS[0].stat === "-") ? (
                teamData.WEAKNESS.map((data, index) => (
                    <div key={`weakness-${index}`}
                         className="flex flex-row justify-between w-full items-center py-0.5 text-sm p-1">
                      <p className="w-3/4 pl-1 whitespace-nowrap overflow-hidden text-ellipsis truncate">{data.txt}</p>
                      <p
                          className={neverLandUtils.classNames(
                              data.stat === "약함" ? "bg-amber-300 text-black" : "bg-rose-700 text-white", "w-16 rounded-full px-1 text-center"
                          )}
                      >
                        {data.stat}
                      </p>
                    </div>
                ))
            ) : (
                <p className="pl-2 text-gray-400">데이터가 없습니다.</p>
            )}
          </div>
        </div>

        {/* <-- 스타일 --> */}
        <div className="flex flex-col mb-3 ring-4 ring-sky-200 m-1 rounded-lg shadow-lg py-1">
          <div className="flex flex-row items-center mb-1 text-sky-600">
            <RiShapesFill className="h-5 w-auto px-2"/>
            <p className="text-lg">스타일</p>
          </div>

          {teamData?.STYLE && teamData.STYLE.length > 0 && !(teamData.STYLE.length === 1 && teamData.STYLE[0] === "-") ? (
              teamData.STYLE.map((style, index) => {
                if (style === "-") return null;
                return (
                    <div key={index} className="flex flex-row w-full items-center py-0.5 text-sm pl-2">
                      <RiCircleFill className="h-2 w-auto pr-1"/>
                      <p className="w-full pl-1 whitespace-nowrap overflow-hidden text-ellipsis truncate">{style}</p>
                    </div>
                )
              })
          ) : (
              <p className="pl-2 text-gray-400">데이터가 없습니다.</p>
          )}
        </div>
      </div>
  )
}
export default GameStrongPoint;